/** Sendbird UIKit copy overrides to match WeRule terminology and UX. */
export const sendbirdStringSet = {
  MODAL__CHANNEL_INFORMATION__TITLE: "Channel information",
  CHANNEL_SETTING__OPERATORS__TITLE: "Group Admins",
  CHANNEL_SETTING__OPERATORS__TITLE_ALL: "All group admins",
  CHANNEL_SETTING__OPERATORS__TITLE_ADD: "Add group admin",
  CHANNEL_SETTING__OPERATORS__ADD_BUTTON: "Add user",
  CHANNEL_SETTING__MEMBERS__OPERATOR: "Group Admin",
  CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: "Add members",
  CHANNEL_SETTING__MODERATION__REGISTER_AS_OPERATOR: "Promote to Group Admin",
  CHANNEL_SETTING__MODERATION__UNREGISTER_OPERATOR: "Remove Group Admin",
};
